import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.signalR$) signalR$: Observable<boolean>;

  s: Subscription;

  signalRStatus: boolean = false;

  constructor(private translateService: TranslateService,
    ) { }

  ngOnInit() {
    this.s = this.signalR$.subscribe(res => {
      this.signalRStatus = res;
    });
  }

  ngOnDestroy() {
    this.s?.unsubscribe();
  }

  GetTooltip() {
    return this.signalRStatus ? this.translateService.instant('SignalR.Connected'): this.translateService.instant('SignalR.Disconnected');
  }

  CheckSignalR() {
    return this.signalRStatus;
  }
}
